export default {
  methods: {
    focusTo(event, rowIndex, columnIndex) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode === 13) {
        if (this.hasCell(rowIndex, columnIndex + 1)) {
          this.moveToCell(rowIndex, columnIndex + 1);
        } else {
          this.moveToCell(rowIndex + 1, 0);
        }
        return;
      }
      if ([37, 38, 39, 40].includes(charCode)) {
        event.preventDefault();
        if (charCode === 38) { // up
          rowIndex -= 1;
        } else if (charCode === 40) { // down
          rowIndex += 1;
        } else if (charCode === 37) { // left
          columnIndex -= 1;
        } else if (charCode === 39) { // right
          columnIndex += 1;
        }
        this.moveToCell(rowIndex, columnIndex);
      }
    },

    moveToCell(rowIndex, columnIndex) {
      const elements = this.$refs[`${rowIndex}-${columnIndex}`];
      const target = elements instanceof Array ? elements[0] : elements;
      if (target) {
        target.focus();
      }
    },

    hasCell(rowIndex, columnIndex) {
      return !!this.$refs[`${rowIndex}-${columnIndex}`];
    },
  },
};
